<script lang="ts">
  import { Translation } from "../i18n/Translation"
  import type { Store } from "../../Logic/UIEventSource"
  import Tr from "./Tr.svelte"

  export let t: Store<Translation>
</script>

<Tr t={$t} />
